module.exports = __webpack_public_path__ + "img/71400.e47daef7.jpg";